import React from "react";
import PropTypes from "prop-types";
import { Button, Typography } from "@material-ui/core";

import { useStyles } from "./SetupSection.styles";

const SetupSection = ({
  image,
  description,
  access,
  btnLabel,
  btnIcon,
  btnAction,
  extraClass,
  sectionClass,
}) => {
  const classes = useStyles();

  return (
    <div className={(classes.contentBody, extraClass)}>
      <div className={[classes.uploadSection, sectionClass].join(" ")}>
        <img src={image} alt="upload"></img>
        <Typography variant="h6" className={classes.desc}>
          {description}
        </Typography>
        {access && (
          <Button
            name="event"
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={btnAction}
          >
            {btnIcon} {btnLabel}
          </Button>
        )}
      </div>
    </div>
  );
};

SetupSection.propTypes = {
  image: PropTypes.any,
  description: PropTypes.string,
  access: PropTypes.bool,
  btnLabel: PropTypes.string,
  btnIcon: PropTypes.node,
  btnAction: PropTypes.func,
  extraClass: PropTypes.string,
  sectionClass: PropTypes.string,
};

export { SetupSection };
